/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import AirBaloonIcon from '@/assets/images/icons/AirBaloonIcon';
import CartIcon from '@/assets/images/icons/CartIcon';
import FourIcon from '@/assets/images/icons/FourIcon';
import InfoIcon from '@/assets/images/icons/InfoIcon';
import MoneyExchangeIcon from '@/assets/images/icons/MoneyExchangeIcon';
import MoneyMoveIcon from '@/assets/images/icons/MoneyMoveIcon';
import TransactionsIcon from '@/assets/images/icons/TransactionsIcon';
import KDIF from '@/assets/images/KDIF.svg';
import InternationalIcon from '@/assets/images/Online.svg';
import { BigTitle, BodyText, Button, Modal, SubTitle, Title } from '@/components';
function LandingDepositBenefits() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const benefits = [
    { icon: <FourIcon />, caption: t('deposit.deposit_benefits.card_1') },
    {
      icon: <img src={InternationalIcon} alt='' tw='sm:w-[80px] w-[52px]' />,
      caption: t('deposit.deposit_benefits.card_2')
    },
    { icon: <MoneyMoveIcon />, caption: t('deposit.deposit_benefits.card_3') },
    { icon: <MoneyExchangeIcon />, caption: t('deposit.deposit_benefits.card_4') },
    { icon: <CartIcon />, caption: t('deposit.deposit_benefits.card_5') },
    { icon: <TransactionsIcon />, caption: t('deposit.deposit_benefits.card_6') },
    {
      icon: <AirBaloonIcon />,
      caption: (
        <span>
          Получение пластиковой карты в любом <a tw='underline cursor-pointer'>отделении банка</a>
        </span>
      )
    },
    {
      icon: <InfoIcon />,
      caption: (
        <span>
          Справки для виз и налоговой
          {/* <a href='/' tw='underline'>
            “Мои документы”
          </a> */}
        </span>
      )
    }
  ];
  return (
    <>
      <div>
        <BigTitle
          text={t('deposit.deposit_benefits.title')}
          twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] sm:mb-20 mb-10`}
        />
        <div tw='sm:grid flex flex-col grid-cols-4 gap-5'>
          {benefits.map((card, index) => (
            <div tw='bg-[#444444] rounded-[20px] p-5 pt-2 flex flex-col sm:gap-5 gap-0' key={card.caption + index}>
              <div tw='h-[80px] flex items-center '>{card.icon}</div>
              <BodyText text={card.caption} twStyle={tw``} />
            </div>
          ))}
        </div>
        <div tw='flex sm:flex-row flex-col gap-3 mt-5 sm:w-[95%]'>
          <div tw='bg-[#444444] rounded-xl p-5 flex flex-col sm:gap-10 gap-5'>
            <div tw=''>
              <BigTitle text={t('deposit.deposit_benefits.card_9.title')} twStyle={tw`text-[#70FF6E] mb-5`} />
              <BodyText text={t('deposit.deposit_benefits.card_9.subtitle')} twStyle={tw``} />
            </div>
            <div tw='sm:flex grid grid-cols-2 justify-between'>
              <div>
                <BigTitle text={t('deposit.deposit_benefits.card_9.card1_title')} />
                <BodyText text={t('deposit.deposit_benefits.card_9.card1_caption')} twStyle={tw`text-secondary`} />
              </div>
              {/* <div>
                <BigTitle text={t('deposit.deposit_benefits.card_9.card2_title')} />
                <BodyText text={t('deposit.deposit_benefits.card_9.card2_caption')} twStyle={tw`text-secondary`} />
              </div> */}
            </div>
          </div>
          <div tw='bg-[#444444] rounded-xl p-5  flex flex-col gap-5 sm:max-w-[300px]'>
            <img src={KDIF} alt='icon' tw='w-[120px]' />
            <BodyText
              twStyle={tw``}
              text={
                <span>
                  <span tw='font-bold'>Счета и вклады иностранных граждан защищены </span>государственной системой
                  гарантирования депозитов на сумму до 20 млн тг.{' '}
                  <span tw='underline cursor-pointer' onClick={() => setOpen(true)}>
                    Подробнее
                  </span>
                </span>
              }
            />
          </div>
        </div>
      </div>

      <Modal
        setOpen={setOpen}
        open={open}
        twStyle={tw`rounded-2xl sm:max-w-[800px] max-w-[95vw] flex flex-col max-h-[90vh]`}
      >
        <Title twStyle={tw`sm:mb-10 mb-5`} text={'Государственная защита счетов и вкладов'} variant={'bold'} />
        <SubTitle
          twStyle={tw`sm:text-s18 text-s14`}
          text={
            <span>
              Счета и вклады иностранных граждан, открытые в АО “Фридом Банк Казахстан”, защищены Казахстанским Фондом
              Гарантирования Депозитов. <br />
              Гарантия распространяется на вклады, вознаграждения по ним, деньги на текущих счетах и платежных
              карточках.
              <br />
              Максимальная сумма гарантии: <br />
              <ul>
                <li>20 миллионов тенге по сберегательным вкладам в тенге;</li>
                <li>10 миллионов тенге по карточкам, счетам и другим депозитам в тенге;</li>
                <li>
                  5 миллионов тенге по карточкам, счетам и депозитам в иностранной валюте (в эквиваленте по курсу,
                  установленному на дату лишения банка-участника лицензии).
                </li>
              </ul>
              <br />
              Если в одном банке-участнике размещено несколько депозитов, различных по видам и валюте, то гарантируется
              совокупный остаток суммы по всем депозитам, но не более максимальной суммы гарантийного возмещения – 20
              миллионов тенге, с учетом пределов по каждому виду депозита.
              <br />
              Подробнее —
              <a
                href='https://kdif.kz/?ysclid=le4j2sqp9w439792884'
                target='_blank'
                rel='noreferrer'
                tw='text-[#70FF6E]'
                onClick={() => window.open('https://kdif.kz/?ysclid=le4j2sqp9w439792884', '_blank')}
              >
                на сайте КФГД
              </a>
            </span>
          }
        />
        <Button
          variant='ghost'
          twStyle={tw`rounded-md sm:max-w-[150px] max-w-[] sm:mt-10 mt-5`}
          onClick={() => setOpen(false)}
        >
          Закрыть
        </Button>
      </Modal>
    </>
  );
}

export default LandingDepositBenefits;
